import AutoComplete from '@tarekraafat/autocomplete.js';
import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';
import PhotoQuickSearch, {
    PhotoQuickSearchElements,
    PhotoQuickSearchSelectors,
    PhotoQuickSearchTexts,
    PhotoQuickSearchClassList
} from 'ui-theme/widgets/quick-search/js/quick-search';

class Texts extends PhotoQuickSearchTexts {}

class ClassList extends PhotoQuickSearchClassList {}

class Selectors extends PhotoQuickSearchSelectors {}

class Elements extends PhotoQuickSearchElements {}

interface QuickSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}
class QuickSearchElm {
    constructor(public el: HTMLInputElement, public searchType: string, public seriesKey: string) { }
}
@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends PhotoQuickSearch {
    protected getConfigs(quickSearchElm: QuickSearchElm, autoCompleteObj: AutoComplete) {
        return {
            data: {
                src: async () => {
                    let url = this.buildFetchURL(quickSearchElm);
                    if (url) {
                        const numOfJournals = quickSearchElm.el.dataset.numOfJournals;
                        const numOfGroups = quickSearchElm.el.dataset.numOfGroups;
                        const contentSuppression = quickSearchElm.el.dataset.contentSuppression;
                        if(contentSuppression === 'true') {
                            url += '&access=user';
                        }
                        const data = await fetch(url);
                        const results = await data.json();

                        if (numOfJournals || numOfGroups) {
                            const seriesItems = results.filter(item => item.param === "SeriesKey");
                            const groupItems = results.filter(item => item.param === "ContentGroupKey");
                            const otherItems = results.filter(item => item.param !== "SeriesKey" && item.param !== "ContentGroupKey");

                            const prioritizedSeriesItems = seriesItems.slice(0, parseInt(numOfJournals || "0"));
                            const prioritizedGroupItems = groupItems.slice(0, parseInt(numOfGroups || "0"));

                            const remainingSlots = Math.max(0, 10 - (prioritizedSeriesItems.length + prioritizedGroupItems.length));
                            return [
                                ...prioritizedSeriesItems,
                                ...prioritizedGroupItems,
                                ...otherItems.slice(0, remainingSlots)
                            ];
                        } else {
                            return results;
                        }
                    } else {
                        return [];
                    }
                },
                cache: false
            },
            selector: () => quickSearchElm.el,
            resultsList: this.resultListConfig(quickSearchElm),
            events: {
                input: {
                    blur: (event) => {
                        setTimeout(() => {                            
                            autoCompleteObj.close(autoCompleteObj.input);
                        }, 200);
                    }
                }
            },
            ...this.defaultConfigs
        };
    }
}

export default QuickSearch;